import { FetchedMaterial } from "../../../student_history/detail/StudentHistoryDetail";

export const AllocatedMaterials = ({ 
  materials, 
  isLoading, 
  hideBatchInfo = false,
  isFinalizedPresent = false,
}: { 
  materials: FetchedMaterial[], 
  isLoading: boolean,
  hideBatchInfo?: boolean,
  isFinalizedPresent?: boolean,
}) => {
  if (isLoading) {
    return (
      <div className="mt-6 flex flex-col gap-2 rounded-lg border bg-secondary/30 p-5 shadow-sm animate-pulse">
        <div className="h-4 w-40 bg-muted-foreground/20 rounded"></div>
        <div className="space-y-3 mt-4">
          <div className="h-16 w-full bg-muted-foreground/10 rounded-lg"></div>
          <div className="h-16 w-full bg-muted-foreground/10 rounded-lg"></div>
        </div>
      </div>
    );
  }

  if (!materials || materials.length === 0) return null;

  return (
    <div className="mt-6 flex flex-col gap-4 rounded-lg border bg-secondary/20 p-5 shadow-sm">
      <div className="flex items-center justify-between border-b border-border/60 pb-3">
        <h4 className="text-sm font-bold tracking-wide text-foreground uppercase">
          Assigned Materials
        </h4>
      </div>
      
      <ul className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-2">
        {materials.map((mat) => (
          <li key={mat.id} className="flex flex-col border border-border/50 rounded-md p-4 bg-background">
            
            <div className="flex items-center justify-between mb-4 border-b border-border/50 pb-3">
              <span className="font-semibold text-lg text-foreground">{mat.name}</span>
              <div className="flex flex-wrap items-center gap-2">
                <div className="flex items-center gap-2 bg-primary/10 text-primary px-3 py-1.5 rounded-md border border-primary/20">
                  <span className="text-xs font-bold uppercase tracking-wider">Requested</span>
                  <span className="font-bold whitespace-nowrap">{mat.requestAmount} <span className="font-medium text-xs uppercase">{mat.unit}</span></span>
                </div>
                {hideBatchInfo && mat.allocations.length > 0 && (
                  <div className="flex items-center gap-2 bg-secondary/40 text-foreground px-3 py-1.5 rounded-md border border-border">
                    <span className="text-xs font-bold uppercase tracking-wider">Allocated</span>
                    <span className="font-bold whitespace-nowrap">
                      {mat.allocations.reduce((sum, a) => sum + a.allocatedAmount, 0)} <span className="font-medium text-xs uppercase">{mat.unit}</span>
                    </span>
                  </div>
                )}
              </div>
            </div>
            
            {mat.allocations.length > 0 ? (
              !hideBatchInfo && (
                <div className="space-y-3">
                  {mat.allocations.map((alloc) => {
                    return (
                      <div 
                        key={alloc.batchId} 
                        className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 p-3 bg-background border border-border/60 rounded-lg shadow-sm"
                      >
                        <div className="flex flex-col">
                          <span className="font-semibold text-foreground">{alloc.brand}</span>
                          <span className="text-xs font-mono text-muted-foreground bg-secondary/60 w-fit px-1.5 py-0.5 rounded mt-1 shadow-inner">
                            {alloc.code}
                          </span>
                        </div>
                        
                        <div className="flex items-stretch rounded-md border border-border/80 overflow-hidden shadow-sm">
                          
                          <div className="flex flex-col items-center justify-center px-4 py-2 bg-secondary/40 min-w-[120px]">
                            <span className="text-[10px] font-bold text-muted-foreground uppercase tracking-widest mb-0.5">Allocated</span>
                            <span className="text-sm font-bold text-foreground text-center">
                              {alloc.allocatedAmount} <span className="text-xs font-medium text-muted-foreground uppercase">{mat.unit}</span>
                            </span>
                          </div>

                        </div>
                      </div>
                    );
                  })}
                </div>
              )
            ) : (
              <div className="p-4 rounded-lg bg-background border border-dashed border-border text-sm text-center text-muted-foreground">
                {isFinalizedPresent
                  ? "No material was used for this request."
                  : "Waiting for staff to allocate batches for this material."}
              </div>
            )}
          </li>
        ))}
      </ul>


    </div>
  );
};
